type Reaction = {
  __typename?: 'message_reaction';
  id?: string | null;
  content?: string | null;
};

export default function getInsertedReactions(
  currentReactions: Reaction[] | null | undefined,
  newReaction: Reaction,
) {
  if (!newReaction?.content) {
    return currentReactions || [];
  }

  const reactions = currentReactions || [];
  const alreadyExists = reactions.some(
    (reaction) =>
      reaction.content === newReaction.content ||
      reaction.id === newReaction.id,
  );

  if (alreadyExists) {
    return reactions;
  }

  return [
    ...reactions,
    {
      __typename: 'message_reaction',
      id: newReaction.id,
      content: newReaction.content,
    },
  ];
}
